var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-table',{ref:"baseTable",attrs:{"service":_vm.codeService,"fetch-func":"all","fetch-params":_vm.params,"columns":_vm.$options.columns,"per-page":_vm.$options.perPage,"prepend":_vm.$options.prepend,"checkable":true,"checked":_vm.checked,"sticky":true,"infinite-scroll":true},on:{"check":_vm.onCheck}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f81e3f2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Assets/list/partials/tableClass.vue
// module id = null
// module chunks = 